<template>
    <div v-if="state?.visible" class="safetyStatusRow">
        <span class="safetyStatus" :class="state.className">{{ state.label }}</span>
        <span
            v-if="tooltip"
            class="safetyHelp"
            :title="tooltip"
            aria-label="View safety lookup response"
        >?</span>
    </div>
</template>

<script>
export default {
    name: "RedirectSafetyStatus",
    props: {
        state: {
            type: Object,
            required: true,
        },
        tooltip: {
            type: String,
            default: "",
        },
    },
};
</script>

<style scoped>
.safetyStatusRow {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 10px;
}

.safetyStatus {
    font-size: 0.95rem;
    font-weight: 700;
}

.safetyStatus.isOk {
    color: #157347;
}

.safetyStatus.isBlocked {
    color: #b42318;
}

.safetyStatus.isPending {
    color: var(--qrce-muted);
}

.safetyHelp {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border: 1px solid currentColor;
    border-radius: 999px;
    color: var(--qrce-muted);
    font-size: 0.85rem;
    font-weight: 700;
    cursor: help;
    user-select: none;
}
</style>
